var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.activities),function(activity){return [_c('action-button',{key:activity.ID,attrs:{"state":activity.Enable,"hover-img":activity.HoverUrl,"navigate-url":activity.NavigateUrl}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }